// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SignalStageSchema = z.enum(['NEW','IN_TESTING','NEEDS_REVIEW','TESTED'] as const);

export type SignalStageType = `${z.infer<typeof SignalStageSchema>}`

export default SignalStageSchema;
